import { render, staticRenderFns } from "./scenario-question-component.vue?vue&type=template&id=4e0cbee9&scoped=true&"
import script from "./scenario-question-component.vue?vue&type=script&lang=ts&"
export * from "./scenario-question-component.vue?vue&type=script&lang=ts&"
import style0 from "./scenario-question-component.vue?vue&type=style&index=0&id=4e0cbee9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e0cbee9",
  null
  
)

export default component.exports